import Pagination from 'react-bootstrap/Pagination';

const PaginationComponent = ({current, totalPages, navigate}) => {

    return(
        <div className="flex-row" style={{justifyContent:'center'}}>
            <Pagination>
                {
                    current-1 === 1?
                    <>
                        <Pagination.First onClick={() => navigate(1)}/>
                        <Pagination.Item onClick={() => navigate(current-1)}>{current-1}</Pagination.Item>
                    </>:
                    <></>
                }
                {
                    current-2 >= 1?
                    <>
                        <Pagination.First onClick={() => navigate(1)}/>
                        <Pagination.Prev onClick={() => navigate(current-1)}/>
                        <Pagination.Item onClick={() => navigate(1)}>{1}</Pagination.Item>
                        <Pagination.Ellipsis onClick={() => navigate(Math.round((current-1)/2))}/>
                        <Pagination.Item onClick={() => navigate(current-1)}>{current-1}</Pagination.Item>
                    </>:
                    <></>
                }
                <Pagination.Item active>{current}</Pagination.Item>
                {
                    current+2 <=totalPages?
                    <>
                        <Pagination.Item onClick={() => navigate(current+1)}>{current+1}</Pagination.Item>
                        <Pagination.Ellipsis onClick={() => navigate(Math.round((totalPages-current)/2)+current)}/>
                        <Pagination.Item onClick={() => navigate(totalPages)}>{totalPages}</Pagination.Item>
                        <Pagination.Next onClick={() => navigate(current+1)}/>
                        <Pagination.Last onClick={() => navigate(totalPages)}/>
                    </>:
                    <></>
                }
                {
                    current+1 === totalPages?
                    <>
                        <Pagination.Item onClick={() => navigate(totalPages)}>{totalPages}</Pagination.Item>
                        <Pagination.Last onClick={() => navigate(totalPages)}/>
                    </>:
                    <></>
                }
            </Pagination>
        </div>
    )
}

export default PaginationComponent
